window.addEventListener('error', (e) => {
	if (e.message && /ResizeObserver.*loop/i.test(e.message)) {
		e.stopImmediatePropagation()
	}
}, true)

const originalConsoleError = console.error
console.error = (...args) => {
	if (args.some(arg => typeof arg === 'string' && /ResizeObserver.*loop/i.test(arg))) {
		return
	}
	originalConsoleError.apply(console, args)
}


import { createApp, h } from 'vue'
import App from './App.vue'
//utils
import publicMethods from './utils/publicMethods.js'
import { escapeHtml, highlight, sanitizeHtml, safeLink } from './utils/safeHtml.js'
import time from './utils/time.js'
import axios from './utils/axios.js'
import config from './utils/config.js'
import device from './utils/device.js'
import drag from './utils/drag.js'
import guid from './utils/guid.js'
import crypto from './utils/crypto.js'
import speak from './utils/speechSynthesis'
import { setApp } from './utils/app.js'
// 导入路由
import router from './router'

// 引入 Pinia
import { createPinia } from 'pinia'
// 导入持久化插件
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// 引入 Element Plus
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElIcons from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
// 头部下拉弹层的统一配色（要在 element-plus 之后引入才能覆盖）
import './styles/menu-pop.scss'
// 引入 echarts
import * as echarts from 'echarts'


import VueCropper from 'vue-cropper'
import 'vue-cropper/dist/index.css'

// 引入 element-tree-line
import { getElementLabelLine } from 'element-tree-line'
import 'element-tree-line/dist/style.css'

//https://article.juejin.cn/post/7573241978901512207
import vue3TreeOrg from 'vue3-tree-org'
import 'vue3-tree-org/lib/vue3-tree-org.css'

const app = createApp(App)

//保存全局app
setApp(app)

// 👇 重点：全局注册所有图标
for (const [key, component] of Object.entries(ElIcons)) {
	app.component(key, component)
}

// 👇 全局挂载（所有组件可通过 this 访问）
app.config.globalProperties.$config = config
app.config.globalProperties.$http = axios
app.config.globalProperties.$publicMethods = publicMethods
app.config.globalProperties.$time = time
app.config.globalProperties.$echarts = echarts
app.config.globalProperties.$device = device
app.config.globalProperties.$guid = guid
app.config.globalProperties.$speak = speak
app.config.globalProperties.$crypto = crypto

// 👇 XSS 防护：所有模板可直接使用 sanitizeHtml / escapeHtml / highlight
app.mixin({
	methods: {
		escapeHtml,
		highlight,
		sanitizeHtml,
		safeLink
	}
})


app.config.globalProperties.$fullScreen = function() {
	let element = document.documentElement;
	if (element.requestFullscreen) {
		element.requestFullscreen();
	} else if (element.msRequestFullscreen) {
		element.msRequestFullscreen();
	} else if (element.mozRequestFullScreen) {
		element.mozRequestFullScreen();
	} else if (element.webkitRequestFullscreen) {
		element.webkitRequestFullscreen();
	}
	//禁用esc
}

//退出全屏
app.config.globalProperties.$exitFullscreen = function() {
	if (document.exitFullscreen) {
		document.exitFullscreen();
	} else if (document.msExitFullscreen) {
		document.msExitFullscreen();
	} else if (document.mozCancelFullScreen) {
		document.mozCancelFullScreen();
	} else if (document.webkitExitFullscreen) {
		document.webkitExitFullscreen();
	}
	//解除禁用esc
}


//注册 路由
app.use(router)

// 注册 Pinia
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate) // 启用持久化
app.use(pinia)
app.use(VueCropper)
// 注册 v-drag 指令
app.directive('drag', drag)
// 注册 Element Plus
app.use(ElementPlus, { locale: zhCn })


app.use(vue3TreeOrg)
// 全局注册
const ElementTreeLine = getElementLabelLine(h)
app.component(ElementTreeLine.name, ElementTreeLine)

app.mount('#app')